export enum ZpTariff {
    Anonymous = 'ZP_ANONYMOUS',
    ResumeAccessUnlimited = 'ZP_RESUME_ACCESS_UNLIMITED',
    ResumeAccessByPiece = 'ZP_RESUME_ACCESS_BY_PIECE',
    ResumeAccessByCategory = 'ZP_RESUME_ACCESS_BY_CATEGORY',
    OptionPremium = 'OPTION_PREMIUM',
    Branding = 'VBC',
    ZpSprint = 'ZP_SPRINT',
}
